import { render, staticRenderFns } from "./ClearIcon.vue?vue&type=template&id=36a6dd63"
import script from "./ClearIcon.vue?vue&type=script&lang=ts"
export * from "./ClearIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports